<template>
  <div>
    <div class="bg-white dark:bg-slate-800 p-4 rounded-md">
      <woot-loading-state
        v-if="uiFlags"
        class="text-xs"
        :message="$t('REPORT.LOADING_CHART')"
      />
      <LineChart v-else :data="getChartData()" />
    </div>
    <div class="bg-white dark:bg-slate-800 p-4 rounded-md mt-5">
      <woot-loading-state
        v-if="uiFlags"
        class="text-xs"
        :message="$t('REPORT.LOADING_CHART')"
      />
      <div v-else>
        <div class="justify-between flex flex-row items-center">
          <div
            class="text-xl font-bold text-slate-500 dark:text-slate-100 my-1 ml-4"
          >
            {{ $t('WORK_ORDER_REPORTS.PER_STAFF') }}
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div
            v-for="(data, name) in report"
            :key="name"
            class="p-4 bg-gray-50 dark:bg-gray-700 text-slate-500 dark:text-slate-100 mb-8"
          >
            <div class="text-lg mb-1">{{ name }}</div>

            <div class="space-y-1">
              <h1
                class="mb-4"
                :class="{
                  'text-green-500': data.utilitas >= 75,
                  'text-slate-500 dark:text-slate-100': data.utilitas < 75,
                }"
              >
                {{ data.utilitas }}%
              </h1>
              <div class="flex flex-row mt-4">
                <div class="flex flex-col">
                  <div class="text-sm">{{ $t('WORK_ORDER_REPORTS.LABEL') }}</div>
                  <div class="text-lg text-yellow-500 dark:text-yellow-100">
                    {{ data.total_work_order }}
                  </div>
                </div>
                <div class="flex flex-col ml-8">
                  <div class="text-sm">{{ $t('WORK_ORDER_REPORTS.WORKING_TIME') }}</div>
                  <div class="text-lg text-yellow-500 dark:text-yellow-100">
                    {{ formatWorkingTime(data.total_working_time) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reportMixin from 'dashboard/mixins/reportMixin';
import LineChart from './components/ChartElements/LineChart.vue';

export default {
  mixins: [reportMixin],
  components: { LineChart },
  props: {
    report: {
      type: Object,
      required: true,
    },
    uiFlags: {
      type: Boolean,
      required: false,
    },
  },

  methods: {
    formatWorkingTime(minutes) {
      if (!minutes) return `0 ${this.$t('WORK_ORDER_REPORTS.TIME.HOURS')} 0 ${this.$t('WORK_ORDER_REPORTS.TIME.MINUTES')}`;

      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;

      return `${hours} ${this.$t('WORK_ORDER_REPORTS.TIME.HOURS')} ${remainingMinutes} ${this.$t('WORK_ORDER_REPORTS.TIME.MINUTES')}`;
    },

    getChartData() {
      return this.getLineChartData(this.report);
    },
  },
};
</script>
